<template>
  <v-simple-checkbox
    v-ripple
    v-model="model"
    v-bind="$attrs"
  ></v-simple-checkbox>
</template>

<script>
import { defineComponent, ref, watch, getCurrentInstance } from 'vue'

export default defineComponent({
  props: {
    value: {},
    trueValue: { default: true },
    falseValue: { default: false },
  },
  setup(props) {

    const model = ref()
    const { proxy } = getCurrentInstance()

    watch(() => props.value, v => {
      model.value = (v === props.trueValue)
    }, { immediate: true })

    watch(model, v => {
      proxy.$emit('input', v ? props.trueValue : props.falseValue)
    })

    return {
      model,
    }

  },
})
</script>
